export enum BankHandlerCode {
  LEUMI = "10",
  DISCOUNT = "11",
  HAPOALIM = "12",
  IGUD = "13",
  OTSAR_HAHAYAL = "14",
  MERCANTILE = "17",
  DIGITAL_FIRST = "18",
  MIZRAHI_TEFAHOT = "20",
  CITIBANK = "22",
  HSBC = "23",
  BNP_PARIBAS = "25",
  U_BANK = "26",
  BARCLAYS = "27",
  TRADE = "30",
  FIBI = "31",
  ARAB_ISRAELI = "34",
  SBI = "39",
  MASSAD = "46",
  JERUSALEM = "54",
  POST = "09",
  YAHAV = "04"
}

export const formatBankHandlerCode = (code: BankHandlerCode | string): string => {
  switch (code) {
    case BankHandlerCode.LEUMI:
      return "בנק לאומי";
    case BankHandlerCode.DISCOUNT:
      return "בנק דיסקונט";
    case BankHandlerCode.HAPOALIM:
      return "בנק הפועלים";
    case BankHandlerCode.IGUD:
      return "בנק אגוד";
    case BankHandlerCode.OTSAR_HAHAYAL:
      return "בנק אוצר החייל";
    case BankHandlerCode.MERCANTILE:
      return "בנק מרכנתיל דיסקונט";
    case BankHandlerCode.DIGITAL_FIRST:
      return "ONE ZERO";
    case BankHandlerCode.MIZRAHI_TEFAHOT:
      return "בנק מזרחי‑טפחות";
    case BankHandlerCode.CITIBANK:
      return "סיטיבנק N.A.";
    case BankHandlerCode.HSBC:
      return "HSBC בנק";
    case BankHandlerCode.BNP_PARIBAS:
      return "BNP Paribas Israel";
    case BankHandlerCode.U_BANK:
      return "יובנק";
    case BankHandlerCode.BARCLAYS:
      return "ברקליס בנק";
    case BankHandlerCode.TRADE:
      return "בנק למסחר";
    case BankHandlerCode.FIBI:
      return "הבנק הבינלאומי הראשון לישראל";
    case BankHandlerCode.ARAB_ISRAELI:
      return "בנק ערבי ישראלי";
    case BankHandlerCode.SBI:
      return "בנק SBI (State Bank of India)";
    case BankHandlerCode.MASSAD:
      return "בנק מסד";
    case BankHandlerCode.JERUSALEM:
      return "בנק ירושלים";
    case BankHandlerCode.POST:
      return "בנק הדואר";
    case BankHandlerCode.YAHAV:
      return "בנק יהב";
    default:
      return code;
  }
};

export const getAllBankHandlerCodes = (): Array<{ value: BankHandlerCode; label: string }> => {
  return [
    { value: BankHandlerCode.POST, label: formatBankHandlerCode(BankHandlerCode.POST) },
    { value: BankHandlerCode.YAHAV, label: formatBankHandlerCode(BankHandlerCode.YAHAV) },
    { value: BankHandlerCode.LEUMI, label: formatBankHandlerCode(BankHandlerCode.LEUMI) },
    { value: BankHandlerCode.DISCOUNT, label: formatBankHandlerCode(BankHandlerCode.DISCOUNT) },
    { value: BankHandlerCode.HAPOALIM, label: formatBankHandlerCode(BankHandlerCode.HAPOALIM) },
    { value: BankHandlerCode.IGUD, label: formatBankHandlerCode(BankHandlerCode.IGUD) },
    { value: BankHandlerCode.OTSAR_HAHAYAL, label: formatBankHandlerCode(BankHandlerCode.OTSAR_HAHAYAL) },
    { value: BankHandlerCode.MERCANTILE, label: formatBankHandlerCode(BankHandlerCode.MERCANTILE) },
    { value: BankHandlerCode.DIGITAL_FIRST, label: formatBankHandlerCode(BankHandlerCode.DIGITAL_FIRST) },
    { value: BankHandlerCode.MIZRAHI_TEFAHOT, label: formatBankHandlerCode(BankHandlerCode.MIZRAHI_TEFAHOT) },
    { value: BankHandlerCode.CITIBANK, label: formatBankHandlerCode(BankHandlerCode.CITIBANK) },
    { value: BankHandlerCode.HSBC, label: formatBankHandlerCode(BankHandlerCode.HSBC) },
    { value: BankHandlerCode.BNP_PARIBAS, label: formatBankHandlerCode(BankHandlerCode.BNP_PARIBAS) },
    { value: BankHandlerCode.U_BANK, label: formatBankHandlerCode(BankHandlerCode.U_BANK) },
    { value: BankHandlerCode.BARCLAYS, label: formatBankHandlerCode(BankHandlerCode.BARCLAYS) },
    { value: BankHandlerCode.TRADE, label: formatBankHandlerCode(BankHandlerCode.TRADE) },
    { value: BankHandlerCode.FIBI, label: formatBankHandlerCode(BankHandlerCode.FIBI) },
    { value: BankHandlerCode.ARAB_ISRAELI, label: formatBankHandlerCode(BankHandlerCode.ARAB_ISRAELI) },
    { value: BankHandlerCode.SBI, label: formatBankHandlerCode(BankHandlerCode.SBI) },
    { value: BankHandlerCode.MASSAD, label: formatBankHandlerCode(BankHandlerCode.MASSAD) },
    { value: BankHandlerCode.JERUSALEM, label: formatBankHandlerCode(BankHandlerCode.JERUSALEM) },
  ];
};
